import request from '@/utils/request'

export function CheckApplied(empNo) {
    return request({
        url:`/api/Applied/${empNo}/checkApplied`,
        method:'get',
    })
}

export function SaveApplied(empNo,empName) {
    return request({
        url:`/api/Applied/saveApplied?empNo=${empNo}&empName=${empName}`,
        method:'post',
    })
}